// Entry point for the build script in your package.json

import '@hotwired/turbo-rails';
import { StreamActions } from "@hotwired/turbo"
import { createConsumer } from '@rails/actioncable';
import TurboPower from 'turbo_power'
import 'apexcharts';
import 'cally';
import './controllers';

const App = {};
App.cable = createConsumer();

window.App = App;

TurboPower.initialize(StreamActions)

StreamActions.open_modal = function() {
  const modal_id = this.getAttribute("modal_id")
  const modal = document.querySelector(modal_id)
  modal.classList.remove("hidden")
  modal.showModal()
}

StreamActions.upsert_modal = function() {
  const modal_id = this.getAttribute("modal_id")
  const modal_html = this.getAttribute("html")
  const modal = document.querySelector(modal_id)

  if(modal) {
    modal.remove()
  }

  document.body.insertAdjacentHTML("beforeend", modal_html);
}

StreamActions.close_modal = function() {
  document.querySelectorAll("dialog").forEach(dialog => {
    dialog.close()
  })
}
